











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingEngagementCard_insights",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInsightsCard_insights"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingEngagement",
      "kind": "LinkedField",
      "name": "meetingEngagement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "all",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamInsights",
  "abstractKey": null
};

(node ).hash = "13410f0e6918919aa4cb7a9f7b9745fc";

export default node;
